import { render, staticRenderFns } from "./WithdrawCoupon.vue?vue&type=template&id=fd6a6ef2&"
import script from "./WithdrawCoupon.vue?vue&type=script&lang=ts&"
export * from "./WithdrawCoupon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports